import { useGlobalConfig } from '@ad-lucy/context/adData';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { LoggerService } from '../../context/LoggerService';

const logger = LoggerService.getLogger().getModuleLogger('Translations Provider');

// Read country code from global config and set language accordingly.
export function Translations(): null {
  const { i18n } = useTranslation();

  const globalConfig = useGlobalConfig().data;

  useEffect(() => {
    if (!globalConfig) {
      return;
    }

    const countryCode = globalConfig?.country?.code;

    if (!countryCode) {
      logger.error('Failed to find country code. Fallback language will be used (English).');
      return;
    }

    i18n
      .changeLanguage(countryCode)
      .catch(() =>
        logger.error(
          `Language could not be set to ${countryCode} for country ${countryCode}. Fallback language will be used (English).`,
        ),
      );
  }, [globalConfig, i18n]);

  return null;
}
